import DetailsRow from './DetailsRow';
import DetailsCell from './DetailsCell';
import LogDetails from './LogDetails';

export { DetailsRow, DetailsCell };

export default LogDetails;
